module.exports = __webpack_public_path__ + "399ae9f1fdea3030965bb26e5f7a1e71.png";